import React, { useState } from "react";
import {
  Checkbox,
  Col,
  Collapse,
  DatePicker,
  Radio,
  Row,
  Input,
  Select,
  Space,
  Switch,
  Button,
  InputNumber,
  Tooltip,
} from "antd";
import "./index.scss";

import Sider from "antd/lib/layout/Sider";
import { WrapIco, ArrowIco, ExpandIco } from "../../assets/customIcons";
import { DatePickerComponent } from "../DatePicker";
import BreachAnalytics from "../BreachAnalitycs";
import DefectRegister from "../../store/defectRegister";
import { observer } from "mobx-react-lite";
import SwitchDistrict from "./SwitchDistrict";
import Districts from "../../store/Districts";
import { runInAction, toJS } from "mobx";
import AuthApi from "../../api/Auth";
import { Buildings } from "../../constants/Enums";
import BadgeComponent from "../BadgeComponent/BadgeComponent";

const { Panel } = Collapse;
const { Option } = Select;
const buildings = [
  { value: Buildings.Living, text: "Жилые" },
  { value: Buildings.Hospital, text: "Лечебные" },
  { value: Buildings.Children, text: "Детские" },
  { value: Buildings.Other, text: "Прочие" },
];

const SideBarComponent = observer((props) => {
  const [collapsed, setCollapsed] = React.useState(false);
  const [showLayers, setShowLayers] = React.useState(true);
  const [expandDistrict, setExpandDistricts] = React.useState(true);
  const [current, setCurrent] = React.useState(false);
  const [today, setToday] = React.useState(true);

  React.useEffect(() => {
    Districts.getDistricts();
    search();
  }, []);

  const showLayersHandler = (e) => {
    setShowLayers(e.target.checked);
    runInAction(() => {
      Districts.districtsLayer(e.target.checked);
      DefectRegister.getRegistry();
    });
  };
  const onLevelChange = (e) => {
    if (
      !DefectRegister.eventLevelArr.includes("MajorAccidents") &&
      e.target.value === "MajorAccidents"
    ) {
      DefectRegister.eventLevelArr.push("MajorAccidents");
      removeEventLevelByName("Planned");
    } else if (e.target.value === "MajorAccidents") {
      removeEventLevelByName("MajorAccidents");
    }
    if (!current && e.target.value === "Current") {
      setCurrent(true);
      
      setToday(false);
      removeEventLevelByName("Today");

      DefectRegister.initialFilter.dateFrom = new Date();
      DefectRegister.initialFilter.dateTo = new Date();
      removeEventLevelByName("Planned");
    } else if (e.target.value === "Current") {
      if (current) {
        setCurrent(false);
        DefectRegister.initialFilter.dateFrom = null;
        DefectRegister.initialFilter.dateTo = null;

        // eventLevelRemove("Current");
      }
    }
    console.log(today, e.target.value);
    if (!today && e.target.value === "Today") {
      setToday(true);
      DefectRegister.eventLevelArr.push("Today");
      setCurrent(false);
      DefectRegister.initialFilter.dateFrom = new Date();
      DefectRegister.initialFilter.dateTo = new Date();
      removeEventLevelByName("Planned");
    } else if (e.target.value === "Today") {
      if (today) {
        setToday(false);
        removeEventLevelByName("Today");
        DefectRegister.initialFilter.dateFrom = null;
        DefectRegister.initialFilter.dateTo = null;
      }
    }
    if (
      !DefectRegister.eventLevelArr.includes("Planned") &&
      e.target.value === "Planned"
    ) {
      DefectRegister.eventLevelArr.push("Planned");
      removeEventLevelByName("MajorAccidents");

      if (current || today) {
        setCurrent(false);
        setToday(false);
        removeEventLevelByName("Today");
      }
    } else if (e.target.value === "Planned") {
      removeEventLevelByName("Planned");
    }
    if (!DefectRegister.eventLevelArr.length) {
      DefectRegister.initialFilter.eventLevel = null;
    } else {
      DefectRegister.initialFilter.eventLevel =
        DefectRegister.eventLevelArr.toString();
    }
  };

  const removeEventLevelByName = (eventName) => {
    if (DefectRegister.eventLevelArr.includes(eventName)) {
      const idx = DefectRegister.eventLevelArr.indexOf(eventName);
      if (idx > -1) {
        DefectRegister.eventLevelArr.splice(idx, 1);
      }
    }
  }

  const disconnectionsChange = (e) => {
    if (e.target.value == "shutdown" && !e.target.checked) {
      runInAction(() => {
        DefectRegister.disconnectionsShutdown = false;
        DefectRegister.initialFilter.disconnections = false;
      });
    } else if (e.target.value == "shutdown" && e.target.checked) {
      runInAction(() => {
        DefectRegister.disconnectionsShutdown = true;
        if (DefectRegister.disconnectionsWithout) {
          DefectRegister.initialFilter.disconnections = null;
        } else {
          DefectRegister.initialFilter.disconnections = true;
        }
      });
    }
    if (e.target.value == "without" && !e.target.checked) {
      runInAction(() => {
        DefectRegister.disconnectionsWithout = false;
        DefectRegister.initialFilter.disconnections = true;
      });
    } else if (e.target.value == "without" && e.target.checked) {
      runInAction(() => {
        DefectRegister.disconnectionsWithout = true;
        if (DefectRegister.disconnectionsShutdown) {
          DefectRegister.initialFilter.disconnections = null;
        } else {
          DefectRegister.initialFilter.disconnections = false;
        }
      });
    }
    if (
      DefectRegister.disconnectionsWithout ===
      DefectRegister.disconnectionsShutdown
    ) {
      DefectRegister.initialFilter.disconnections = null;
    }
  };
  const eliminatedChange = (e) => {
    if (e.target.value == "eliminated" && !e.target.checked) {
      runInAction(() => {
        DefectRegister.eliminated = false;
        DefectRegister.initialFilter.eliminated = false;
      });
    } else if (e.target.value == "eliminated" && e.target.checked) {
      runInAction(() => {
        DefectRegister.eliminated = true;
        // DefectRegister.violated = false;
        DefectRegister.initialFilter.deadlinesViolated = false;
        DefectRegister.initialFilter.eliminated = true;
        if (DefectRegister.notEliminated) {
          DefectRegister.initialFilter.eliminated = null;
        }
      });
    }
    if (e.target.value == "notEliminated" && !e.target.checked) {
      runInAction(() => {
        DefectRegister.notEliminated = false;
        DefectRegister.initialFilter.eliminated = true;
      });
    } else if (e.target.value == "notEliminated" && e.target.checked) {
      runInAction(() => {
        DefectRegister.notEliminated = true;
        if (DefectRegister.eliminated) {
          DefectRegister.initialFilter.eliminated = null;
        } else {
          DefectRegister.initialFilter.eliminated = false;
        }
      });
    }
    if (DefectRegister.eliminated === DefectRegister.notEliminated) {
      DefectRegister.initialFilter.eliminated = null;
    }
    if (DefectRegister.violated === DefectRegister.notViolated) {
      DefectRegister.initialFilter.deadlinesViolated = null;
    }
  };

  const violatedChange = (e) => {
    if (e.target.value == "violated" && !e.target.checked) {
      runInAction(() => {
        DefectRegister.violated = false;
        DefectRegister.initialFilter.deadlinesViolated = false;
      });
    } else if (e.target.value == "violated" && e.target.checked) {
      runInAction(() => {
        DefectRegister.violated = true;
        if (DefectRegister.notViolated) {
          DefectRegister.initialFilter.deadlinesViolated = null;
        } else {
          DefectRegister.initialFilter.deadlinesViolated = true;
        }
      });
    }
    if (e.target.value == "notViolated" && !e.target.checked) {
      runInAction(() => {
        DefectRegister.notViolated = false;
        DefectRegister.initialFilter.deadlinesViolated = true;
      });
    } else if (e.target.value == "notViolated" && e.target.checked) {
      runInAction(() => {
        DefectRegister.notViolated = true;
        if (DefectRegister.violated) {
          DefectRegister.initialFilter.deadlinesViolated = null;
        } else {
          DefectRegister.initialFilter.deadlinesViolated = false;
        }
      });
    }
    if (DefectRegister.violated === DefectRegister.notViolated) {
      DefectRegister.initialFilter.deadlinesViolated = null;
    }
  };

  const onDateChange = (e) => {
    DefectRegister.initialFilter.dateFrom = e && e[0]?.toDate();
    DefectRegister.initialFilter.dateTo = e && e[1]?.toDate();
    props.store.DateFrom = e && e[0]?.toDate();
    props.store.DateTo = e && e[1]?.toDate();

    if (current) {
      // DefectRegister.initialFilter.eliminated = false;
      // DefectRegister.eliminated = false;
      // DefectRegister.notEliminated = true;
      setCurrent(false);
    }

    if(today) {
      setToday(false);
      removeEventLevelByName("Today");
    }

    if (
      DefectRegister.initialFilter.dateFrom !== null &&
      DefectRegister.initialFilter.dateFrom.toLocaleDateString() === new Date().toLocaleDateString() &&
      DefectRegister.initialFilter.dateTo !== null &&
      DefectRegister.initialFilter.dateTo.toLocaleDateString() === new Date().toLocaleDateString()
    ) {
      setCurrent(true);
    }
    DefectRegister.getRegistry();
  };

  const onBuildingsChange = (e) => {
    DefectRegister.buildingArray = e;
    DefectRegister.initialFilter.buildings = e.reduce((a, b) => a | b, 0);
    console.log(
      DefectRegister.initialFilter.buildings,
      DefectRegister.buildingArray,
    );
  };

  const openAnalytics = (e) => {
    e.stopPropagation();
    props.onOpenAnalytics();
  };

  const logout = () => {
    AuthApi.logout().then(() => {
      props.onLogout();
    });
  };
  const search = () => {
    runInAction(() => {
      if (
        !DefectRegister.disconnectionsWithout &&
        !DefectRegister.disconnectionsShutdown
      ) {
        DefectRegister.initialFilter.disconnections = null;
      }
      if (!DefectRegister.eliminated && !DefectRegister.notEliminated) {
        DefectRegister.initialFilter.eliminated = null;
      }
      if (!DefectRegister.violated && !DefectRegister.notViolated) {
        DefectRegister.initialFilter.deadlinesViolated = null;
      }
      if (!DefectRegister.initialFilter.eventLevel) {
        DefectRegister.initialFilter.eventLevel = null;
      }
      DefectRegister.getRegistry();
    });
  };
  const expandButton = (
    <ExpandIco title={"Перейти в аналитику"} onClick={openAnalytics} />
  );

  return (
    <>
      <Sider
        width={361}
        collapsedWidth={20}
        className={"sider-filter"}
        collapsed={collapsed}
        trigger={null}
      >
        <WrapIco
          className={
            !collapsed ? "sider-filter__icon" : "sider-filter__icon rotate"
          }
          onClick={() => {
            DefectRegister.siderCollapsed = !DefectRegister.siderCollapsed;
            setCollapsed(!collapsed);
          }}
        />

        {!collapsed && (
          <Collapse
            expandIconPosition="right"
            bordered={false}
            onChange={(e) => {
              // e.includes("1") && setData(Districts.districts);
            }}
            defaultActiveKey={["2", "3"]}
            expandIcon={({ isActive }) => (
              <ArrowIco className={isActive ? null : "rotate"} />
            )}
            className="site-collapse-custom-collapse"
          >
            <Panel
              header="Фильтры"
              key="2"
              className="site-collapse-custom-panel"
            >
              <div className="filter">
                <Space
                  className="custom-wrapper-btns"
                  style={{ width: "100%" }}
                  direction="vertical"
                >
                  <Tooltip
                    color={"rgba(86,180,164,0.8)"}
                    placement="rightTop"
                    title='Применяется фильтр по статусу инцидента "не согласован". Если фильтр выбран, то выводятся только несогласованные инциденты'
                  >
                    <div>
                      <Checkbox
                        checked={DefectRegister.initialFilter.isNotValid}
                        value={DefectRegister.initialFilter.isNotValid}
                        onChange={(e) => {
                          DefectRegister.initialFilter.isNotValid =
                            e.target.checked;
                        }}
                        className="custom-radio-button"
                      >
                        Не согласованные
                      </Checkbox>
                    </div>
                  </Tooltip>
                </Space>
              </div>
              <div className="filter">
                <Space
                  className="custom-wrapper-btns"
                  style={{ width: "100%" }}
                  direction="vertical"
                >
                  <Tooltip
                    color={"rgba(86,180,164,0.8)"}
                    placement="rightTop"
                    title='Применяется фильтр по статусу инцидента "Согласован". Если фильтр выбран, то выводятся только согласованные инциденты'
                  >
                    <div>
                      <Checkbox
                        checked={DefectRegister.initialFilter.isValid}
                        value={DefectRegister.initialFilter.isValid}
                        onChange={(e) => {
                          DefectRegister.initialFilter.isValid =
                            e.target.checked;
                        }}
                        className="custom-radio-button"
                      >
                        Согласованные
                      </Checkbox>
                    </div>
                  </Tooltip>
                </Space>
              </div>
              <div className="filter">
                <p className="label-filter">Готовые фильтры</p>
                <Space
                  className="custom-wrapper-btns"
                  style={{ width: "100%" }}
                  direction="vertical"
                >
                  <Tooltip
                    color={"rgba(86,180,164,0.8)"}
                    placement="rightTop"
                    title="События за текущие сутки с 00.00"
                  >
                    <div>
                      <Checkbox
                        value="Today"
                        checked={
                          today &&
                          DefectRegister.initialFilter.dateFrom?.toLocaleDateString() ===
                            new Date()?.toLocaleDateString() &&
                          DefectRegister.initialFilter.dateTo?.toLocaleDateString() ===
                            new Date()?.toLocaleDateString() &&
                          DefectRegister.eventLevelArr.includes(
                              "Today",
                          )
                        }
                        onChange={onLevelChange}
                        className="custom-radio-button"
                      >
                        События сегодня
                      </Checkbox>
                    </div>
                  </Tooltip>
                  <Tooltip
                    color={"rgba(86,180,164,0.8)"}
                    placement="rightTop"
                    title='Применяется фильтр по количеству зданий, количеству отключенных абонентов, диаметру трубы установленных в "Настройках параметра инцидента"'
                  >
                    <div>
                      <Checkbox
                        checked={DefectRegister.eventLevelArr.includes(
                          "MajorAccidents",
                        )}
                        value="MajorAccidents"
                        onChange={onLevelChange}
                        className="custom-radio-button"
                      >
                        Крупные аварии
                      </Checkbox>
                    </div>
                  </Tooltip>
                  <Tooltip
                    color={"rgba(86,180,164,0.8)"}
                    placement="rightTop"
                    title="Применяется фильтр по количеству нарушений на сегодня"
                  >
                    <div>
                      <Checkbox
                        value="Current"
                        checked={
                          current &&
                          DefectRegister.initialFilter.dateFrom?.toLocaleDateString() ===
                            new Date()?.toLocaleDateString() &&
                          DefectRegister.initialFilter.dateTo?.toLocaleDateString() ===
                            new Date()?.toLocaleDateString()
                        }
                        onChange={onLevelChange}
                        className="custom-radio-button"
                      >
                        В работе
                      </Checkbox>
                    </div>
                  </Tooltip>
                  <Tooltip
                    color={"rgba(86,180,164,0.8)"}
                    placement="rightTop"
                    title="Плановые отключения на дату"
                  >
                    <div>
                      <Checkbox
                        checked={DefectRegister.eventLevelArr.includes(
                          "Planned",
                        )}
                        value="Planned"
                        onChange={onLevelChange}
                        className="custom-radio-button"
                      >
                        Плановые отключения
                      </Checkbox>
                    </div>
                  </Tooltip>
                </Space>
              </div>
              <div className="filter">
                <p className="label-filter">Готовность</p>
                <Space
                  className="custom-wrapper-btns"
                  style={{ width: "100%" }}
                  direction="horizontal"
                >
                  <Checkbox
                    checked={DefectRegister.eliminated}
                    onChange={eliminatedChange}
                    value="eliminated"
                    className="custom-radio-button"
                  >
                    Устраненные
                  </Checkbox>
                  <Checkbox
                    checked={DefectRegister.notEliminated}
                    onChange={eliminatedChange}
                    value="notEliminated"
                    className="custom-radio-button"
                  >
                    Не устраненные
                  </Checkbox>
                </Space>
              </div>
              <div className="filter">
                <p className="label-filter">Отключение</p>
                <Space
                  className="custom-wrapper-btns"
                  style={{ width: "100%" }}
                  direction="horizontal"
                >
                  <Checkbox
                    checked={DefectRegister.disconnectionsShutdown}
                    value="shutdown"
                    onChange={disconnectionsChange}
                    className="custom-radio-button"
                  >
                    С отключением
                  </Checkbox>

                  <Checkbox
                    checked={DefectRegister.disconnectionsWithout}
                    value="without"
                    onChange={disconnectionsChange}
                    className="custom-radio-button"
                  >
                    Без отключения
                  </Checkbox>
                </Space>
              </div>
              <div className="filter">
                <p className="label-filter">Сроки</p>
                <Space
                  className="custom-wrapper-btns"
                  style={{ width: "100%" }}
                  direction="horizontal"
                >
                  <Checkbox
                    checked={DefectRegister.violated}
                    onChange={violatedChange}
                    className="custom-radio-button"
                    value="violated"
                  >
                    Нарушены
                  </Checkbox>

                  <Checkbox
                    checked={DefectRegister.notViolated}
                    onChange={violatedChange}
                    className="custom-radio-button"
                    defaultChecked
                    value="notViolated"
                  >
                    Не нарушены
                  </Checkbox>
                </Space>
              </div>
              <div className="filter">
                <Select
                  mode="multiple"
                  className="custom-input"
                  value={DefectRegister.buildingArray}
                  placeholder="Здания в зоне отключения"
                  style={{ width: "100%" }}
                  allowClear
                  onChange={onBuildingsChange}
                >
                  {buildings.map((x, idx) => {
                    return (
                      <Option key={idx} value={x.value}>
                        {x.text}
                      </Option>
                    );
                  })}
                </Select>
                <InputNumber
                  value={DefectRegister.initialFilter.diameter}
                  className="custom-input"
                  type="number"
                  style={{ width: "100%" }}
                  placeholder="Диаметр"
                  onChange={(v) => {
                    v > 0 && Number.isInteger(v)
                      ? (DefectRegister.initialFilter.diameter = v)
                      : (DefectRegister.initialFilter.diameter = null);
                  }}
                />
                <div className="filter-range">
                  <DatePickerComponent onChange={onDateChange} />
                </div>
                <Row gutter={8} className="filter__btns">
                  <Col span={12}>
                    <Button
                      onClick={search}
                      className="custom-button"
                      size="large"
                      block
                      type="primary"
                      disabled={DefectRegister.isLoadingRegistryList.value}
                    >
                      Найти
                    </Button>
                  </Col>
                  <Col span={12}>
                    <Button
                      onClick={() => {
                        setCurrent(true);
                        DefectRegister.clearFilters();
                      }}
                      className="custom-button custom-button--outline"
                      size="large"
                      block
                      type="primary"
                    >
                      Очистить
                    </Button>
                  </Col>
                </Row>
              </div>
            </Panel>
            <Panel
              header="Аналитика по нарушениям"
              key="3"
              className="site-collapse-custom-panel"
              // extra={expandButton}
            >
              <BreachAnalytics
                {...DefectRegister.summaryEventData}
                mode="vert"
              />
            </Panel>
            <Panel
              header="Отображение слоев"
              key="1"
              className="site-collapse-custom-panel"
            >
              <ul className="filter-list">
                <li>
                  <Checkbox checked={showLayers} onChange={showLayersHandler}>
                    Административно-территориальное деление
                  </Checkbox>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginTop: "1rem",
                      paddingLeft: "24px",
                    }}
                  >
                    <Checkbox
                      checked={expandDistrict}
                      onChange={(e) => setExpandDistricts(!expandDistrict)}
                    >
                      Административные районы
                    </Checkbox>
                  </div>
                </li>
                {toJS(Districts.districts) &&
                  toJS(Districts.districts).map((d) => {
                    return (
                      expandDistrict && (
                        <SwitchDistrict
                          key={d.id}
                          districtId={d.id}
                          title={d.title}
                        />
                      )
                    );
                  })}
              </ul>
            </Panel>
            {/* <Panel
                header="Личный кабинет"
                key="4"
                className="site-collapse-custom-panel"
              >
                <a onClick={logout}>Выйти</a>
              </Panel> */}
          </Collapse>
        )}
      </Sider>
    </>
  );
});
export default SideBarComponent;
